import "../styles/index.css";
import "../styles/syntax-highlighting.css";
import "@11ty/is-land/is-land.js";

// Import all JavaScript & CSS files from src/_components
import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}";

console.info("Bridgetown is loaded!");
